package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBrandLogoGuidelinesPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("BrandLogoGuidelines.md", FrontMatterElement.Builder { addScalar("title", "Kotlin Festロゴの使用について"); }))
}

@Page("/brand-logo-guidelines")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun BrandLogoGuidelinesPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("kotlin-festロゴ使用ルール") }) {
        org.jetbrains.compose.web.dom.Text("Kotlin Festロゴ使用ルール")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("日本Kotlinユーザーグループ（以下「当団体」といいます）は、参加者、スポンサー、およびコミュニティの皆様にKotlin Festロゴ（以下「当ロゴ」といいます）を使用して、イベントに言及することを歓迎しています。ただし、当ロゴの著作権、または使用を許諾する権利はmoyo (")
        com.varabyte.kobweb.silk.components.navigation.Link("https://moyo-portfolio.studio.site/") {
            org.jetbrains.compose.web.dom.Text("@moyo_door")
        }
        org.jetbrains.compose.web.dom.Text(") に帰属します。ご使用に際しては、以下の諸条件に従って使用いただきますようよろしくお願いいたします。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("使用目的") }) {
        org.jetbrains.compose.web.dom.Text("使用目的")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("使用者は、以下の場合に限り、当ロゴを使用することができます。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当イベントの紹介を目的として使用する場合")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当イベントのスポンサーが、当該提携又はこれに関連する企画、グッズ等において、当ロゴを使用する場合")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("また、上記目的であっても、以下の場合の使用を禁止します。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当ロゴの変形、加工、改変（詳細はダウンロードファイルに付属のガイドラインをお読みください）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当ロゴを他社の商品名、サービス名、商標、ロゴ、企業名等の一部として使用すること。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("スポンサーでないにも関わらず、当団体と何らかの提携関係、パートナーシップ関係等があると誤解を与える目的。又は当団体による承認・後援・推奨等を示唆するような方法で当ロゴを使用すること。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("当団体又は当イベントの誹謗中傷又はその評判を貶めるような方法で当ロゴを使用すること。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("違法、反社会的勢力に関連する内容、わいせつ又は公序良俗に反する内容の媒体等で当ロゴを使用すること。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("その他、当団体が当団体裁量において不適切と判断する方法で当ロゴを使用すること。")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("ロゴ使用ガイドライン") }) {
        org.jetbrains.compose.web.dom.Text("ロゴ使用ガイドライン")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("ロゴを使用する際の表示方法についてはダウンロードファイルに添付されたガイドラインに従ってご利用ください。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("ロゴ使用ルール及びガイドラインの変更") }) {
        org.jetbrains.compose.web.dom.Text("ロゴ使用ルール及びガイドラインの変更")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("当団体は、当団体が必要と判断する場合、あらかじめ通知することなく、いつでも、ロゴ使用ルール及びガイドラインを変更することができます。変更後のロゴ使用ルール及びガイドラインは、当イベントウェブサイト内の適宜の場所に掲示された時点からその効力を生じるものとし、使用者は、変更後も当団体ロゴを使用し続けることにより、変更後のロゴ使用ルール及びガイドラインに同意をしたものとみなされます。")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("class", "markdown-button");attr("href", "https://drive.google.com/file/d/1VsQ0XV_qD90ZiLwzHtUo08HGaeiR9yBA/view?usp=sharing")}) {
            org.jetbrains.compose.web.dom.Text("ダウンロード")
        }
    }
}
